(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["srg-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.SignageStorefrontAnalytics) return;

    const eventTypes = {
      download_guide: 'srg_download_guide',
      download_guide_bottom: 'srg_download_guide',
      read_online: 'srg_read_online',
      read_online_bottom: 'srg_read_online'
    };
    const locations = new Set([
      'hero', 'resources', 'guide_preview', 'bottom', 'online_guide',
      'guide_top', 'guide_bottom', 'cover', 'landing'
    ]);
    let consentFromEvent;

    const consentStatus = () => {
      if (window.Shopify && window.Shopify.designMode) return 'theme_editor';
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy) {
        if (typeof privacy.analyticsProcessingAllowed !== 'function') return 'unavailable';
        try {
          return privacy.analyticsProcessingAllowed() === true ? 'allowed' : 'blocked';
        } catch (error) {
          return 'unavailable';
        }
      }
      if (typeof consentFromEvent === 'boolean') return consentFromEvent ? 'allowed' : 'blocked';
      return 'managed_by_existing_provider';
    };

    const bridge = () => {
      if (typeof window.gtag === 'function') return 'gtag';
      if (Array.isArray(window.dataLayer)) return 'dataLayer';
      return 'custom_event_only';
    };

    window.SignageStorefrontAnalytics = Object.freeze({
      version: '3',
      getStatus: () => ({ bridge: bridge(), consent: consentStatus() })
    });

    document.addEventListener('visitorConsentCollected', (event) => {
      if (event.detail && typeof event.detail.analyticsAllowed === 'boolean') {
        consentFromEvent = event.detail.analyticsAllowed;
      }
    });

    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      const target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
      const link = target && target.closest('a[data-srg-event]');
      if (!link || !link.closest('.srg, .srg-guide') || !link.hasAttribute('href')) return;
      const rawEvent = link.dataset.srgEvent;
      if (!Object.hasOwn(eventTypes, rawEvent)) return;
      const eventType = eventTypes[rawEvent];
      const consent = consentStatus();
      if (consent !== 'allowed' && consent !== 'managed_by_existing_provider') return;

      const location = locations.has(link.dataset.srgLocation)
        ? link.dataset.srgLocation
        : rawEvent.endsWith('_bottom')
          ? 'bottom'
          : link.closest('.srg-guide') ? 'online_guide' : 'landing';
      const payload = {
        event: eventType,
        location: location,
        format: eventType === 'srg_download_guide' ? 'pdf' : 'html'
      };
      const destination = bridge();

      try {
        if (destination === 'gtag') {
          // Shopify's existing tag may not make GA4 a default event destination.
          // Reuse its configured destination only; install no tags or tracking IDs.
          const configured = Array.isArray(window.dataLayer)
            ? [...new Set(window.dataLayer.filter(item => item && item[0] === 'config' && /^G-[A-Z0-9]+$/.test(item[1])).map(item => item[1]))]
            : [];
          const parameters = { location: payload.location, format: payload.format };
          if (configured.length === 1) parameters.send_to = configured[0];
          window.gtag('event', payload.event, parameters);
        } else if (destination === 'dataLayer') {
          window.dataLayer.push(payload);
        } else {
          window.dispatchEvent(new CustomEvent('srg:interaction', { detail: payload }));
        }
      } catch (error) {
        return;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
